import { useEffect, useRef } from "react";
import { generateVisitorId, sendAnalytics } from "../utils/analytics.js";

const useAnalytics = ({ page, publicationId = null, trackingKey = page }) => {
  const visitorIdRef = useRef(generateVisitorId());

  useEffect(() => {
    const pageStartTime = Date.now();
    let durationSent = false;

    sendAnalytics({
      analyticsType: "page_view",
      pageName: page,
      publicationId,
      visitorId: visitorIdRef.current,
      durationMs: 0,
    });

    const sendDuration = () => {
      if (durationSent) return;
      durationSent = true;

      sendAnalytics({
        analyticsType: "page_duration",
        pageName: page,
        publicationId,
        visitorId: visitorIdRef.current,
        durationMs: Date.now() - pageStartTime,
      });
    };

    window.addEventListener("beforeunload", sendDuration);

    return () => {
      sendDuration();
      window.removeEventListener("beforeunload", sendDuration);
    };
  }, [trackingKey, page, publicationId]);
};

export default useAnalytics;
